<template>
  <div id="extend-report" :class="{'index-active': indexActive}">
    <!-- Loader -->
    <loader v-if="!isRender || loaderActive"></loader>

    <!-- 목차선택 -->
    <div class="index-wrap">
      <extend-index :indexActive="indexActive"
                    v-model="data.extend_index"
                    @toggle="toggle => this.indexActive = toggle"
      >
      </extend-index>
      <div v-show="indexActive" class="sidebar-overlay hidden-lg" @click="indexActive = false"></div>
    </div>

    <!-- 조건 입력 폼 -->
    <div v-if="isRender" class="extend-container">
      <div class="extend-header">
        <div class="container">
          <div class="title-box">
            <div class="sub-title margin-bottom-8">
              <span v-if="data.update_date" class="date-tag" style="margin-right: 8px;">저장 {{ data.update_date | nullCheck | formatDate }}</span>
              <span v-if="data.address" class="address-tag">{{ addressTag }}</span>
            </div>
            <div class="header-title">
              <div :class="['state-tag', stateTagClass]">{{ data.extend_grade }}</div>
              <!-- 프로젝트명 수정 영역 -->
              <div v-show="titleEdit" class="title-edit-box">
                <input type="text"
                       maxlength="40"
                       class="hz-input-default hz-input-md project-title"
                       style="margin-left: 8px; width: calc(100% - 56px);"
                       v-model="data.project_name">
                <button type="submit"
                        class="hz-btn-default hz-btn-md"
                        style="width: 40px; float: left; border-left: none; border-color: #ced4da; box-shadow: none;"
                        @click.prevent="titleEdit = false">완료</button>
              </div>
              <div v-show="!titleEdit" class="title-edit-box">
                <p class="project-title" style="max-width: calc(100% - 48px); margin: 0 16px;">{{ data.project_name | nullCheck }}</p>
                <i class="glyphicon glyphicon-pencil" @click="titleEdit = true"></i>
              </div>
            </div>
          </div>
          <div class="btn-box">
            <button v-if="isNewReport || hasAuthReport" type="button" class="hz-btn-primary hz-btn-lg pull-right" style="width: 140px; margin-left: 8px;" @click.prevent="showSaveModal('save')">저장 후 미리보기</button>
            <button v-if="!isNewReport && !hasAuthReport" type="button" class="hz-btn-primary hz-btn-lg pull-right" style="width: 140px; margin-left: 8px;" @click.prevent="openPreview">미리보기</button>
            <button v-if="!isNewReport && hasAuthReport" type="button" class="hz-btn-default hz-btn-lg pull-right" style="margin-left: 8px;" @click.prevent="showSaveModal('copy')">다른이름으로 저장</button>
          </div>
        </div>
      </div>
      <div class="extend-content">
        <div class="container">
          <div class="card">
            <div id="basicInfo" class="card-header">
              <a href="#basicContent" data-toggle="collapse" aria-expanded="true" aria-controls="etcContent">기본조건<i class="glyphicon glyphicon-triangle-bottom pull-right"></i></a>
            </div>
            <div id="basicContent" class="collapse show in" aria-labelledby="basicInfo">
              <div class="card-body">
                <div class="row">
                  <div class="col-md-6" v-show="data.extend_index.plant_summary || data.extend_index.review_result">
                    <h5 class="card-category">
                      사업지분석
                      <button class="hz-btn-default hz-btn-xs" style="margin-left: 8px; line-height: 24px; cursor: pointer" title="사업지분석 새로고침" @click="updateLandInfo">
                        <i class="glyphicon glyphicon-refresh"></i>
                      </button>
                    </h5>
                    <div class="row form-group" v-show="data.extend_index.plant_summary">
                      <label class="col-md-4 col-xs-12">조례정보</label>
                      <div class="form-field col-md-8 col-xs-12">
                        <button type="button" class="hz-btn-default hz-btn-md"
                                style="width: 100%; height: 40px; line-height: 40px; margin-bottom: 4px;"
                                @click="showModal('examineModal')">조례목록</button>
                        <textarea class="hz-input-default" style="width: 100%; padding: 8px;" rows="5"
                                  placeholder="필요한 정보 발췌 후 복사하여 붙여넣기 또는 입력하기"
                                  v-model="data.extend_examine"></textarea>
                      </div>
                    </div>
                    <div class="row form-group" v-show="data.extend_index.review_result">
                      <label class="col-md-4 col-xs-12">검토의견</label>
                      <div class="form-field col-md-8 col-xs-12">
                        <div class="form-group padding-0" style="margin-bottom: 4px;">
                          <ul class="row">
                            <li :class="['review-state-box', 'col-xs-4', { 'review-active': data['extend_grade'] === '가능' }]"
                                @click="changeGrade('가능')">가능</li>
                            <li :class="['review-state-box', 'col-xs-4', 'border-left-none', { 'review-active':  data['extend_grade'] === '보류' }]"
                                @click="changeGrade('보류')">보류</li>
                            <li :class="['review-state-box', 'col-xs-4', 'border-left-none', { 'review-active':  data['extend_grade'] === '불가' }]"
                                @click="changeGrade('불가')">불가</li>
                          </ul>
                        </div>
                        <div class="form-group padding-0">
                          <textarea class="hz-input-default" style="width: 100%; padding: 8px;" rows="5"
                                    placeholder="1.부지정보:"
                                    v-model="data.extend_memo"></textarea>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6" v-show="data.extend_index.module || data.extend_index.inverter">
                    <h5 class="card-category">주요 기자재 계획</h5>
                    <div v-show="data.extend_index.module" class="row form-group">
                      <label class="col-md-4 col-xs-12">모듈<tooltip :title="tooltipObj.module"></tooltip></label>
                      <div class="form-field col-md-8 col-xs-12">
                        <drop-down-list ref="selectModule"
                                        :auth="true"
                                        :dataUrl="dataUrl + '/biz/review/exlist/module/'"
                                        :size="'hz-dropdownlist-md'"
                                        @input="setModuleList"
                                        v-model="selectModule"></drop-down-list>
                        <ul v-if="data.master_module.length > 0" class="select-product-list border-top-none">
                          <li v-for="module in data.master_module" :key="module.module">
                            {{ module.module__name }}
                            <span @click="removeModule(module.module)">x</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div v-show="data.extend_index.inverter" class="row form-group">
                      <label class="col-md-4 col-xs-12">인버터<tooltip :title="tooltipObj.inverter"></tooltip></label>
                      <div class="form-field col-md-8 col-xs-12">
                        <drop-down-list ref="selectInverter"
                                        :auth="true"
                                        :dataUrl="dataUrl + '/biz/review/exlist/inverter/'"
                                        :size="'hz-dropdownlist-md'"
                                        @input="setInverterList"
                                        v-model="selectInverter"></drop-down-list>
                        <ul v-if="data.master_inverter.length > 0" class="select-product-list border-top-none">
                          <li v-for="inverter in data.master_inverter" :key="inverter.inverter">
                            {{ inverter.inverter__name }}
                            <span @click="removeInverter(inverter.inverter)">x</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card">
            <div id="profitInfo" class="card-header">
              <a href="#profitContent" data-toggle="collapse" aria-expanded="true" aria-controls="profitContent">수익조건<i class="glyphicon glyphicon-triangle-bottom pull-right"></i></a>
            </div>
            <div id="profitContent" class="collapse show in" aria-labelledby="profitInfo">
              <div class="card-body">
                <div v-show="data.extend_index.profit_option" class="row margin-bottom-48">
                  <div class="col-md-6">
                    <div class="row form-group">
                      <label class="col-md-4 col-xs-12">설치용량<tooltip :title="tooltipObj.expect_capacity"></tooltip></label>
                      <div class="form-field col-md-8 col-xs-12">
                        <input type="number" class="hz-input-default hz-input-md"
                               @input="toFixed('expect_capacity')"
                               v-model="data.extend_profit_condition.expect_capacity">
                        <span class="hz-unit">kWp</span>
                      </div>
                    </div>
                    <div class="row form-group">
                      <label class="col-md-4 col-xs-12">사업지유형<tooltip :title="tooltipObj.plant_type"></tooltip></label>
                      <div class="form-field col-md-8 col-xs-12 padding-0">
                        <drop-down-list :options="[{name: '건물', value: 'BD'}, {name: '토지', value: 'LD'}, {name: '임야', value: 'MT'}, {name: '수상', value: 'WT'}, {name: '자가용 발전설비', value: 'PP'}]"
                                        :label="''" :size="'hz-dropdownlist-md'" v-model="data.extend_profit_condition.plant_type" @input="getRecWeight"></drop-down-list>
                      </div>
                    </div>
                    <div class="row form-group">
                      <label class="col-md-4 col-xs-12">kW당 공사비<tooltip :title="tooltipObj.unit_price"></tooltip></label>
                      <div class="form-field col-md-8 col-xs-12">
                        <input type="number" class="hz-input-default hz-input-md"
                               @input="toFixed('unit_price')"
                               v-model="data.extend_profit_condition.unit_price">
                        <span class="hz-unit">만원/kW</span>
                      </div>
                    </div>
                    <div class="row form-group related-field">
                      <label class="col-md-4 col-xs-12">총 공사비<tooltip :title="tooltipObj.install_fee"></tooltip></label>
                      <div class="form-field col-md-8 col-xs-12">
                        <input type="number" class="hz-input-default hz-input-md"
                               @input="toFixed('install_fee')"
                               v-model="data.extend_profit_condition.install_fee">
                        <span class="hz-unit">백만원</span>
                      </div>
                    </div>
                    <div class="row form-group">
                      <label class="col-md-4 col-xs-12">
                        계통연계비
                        <tooltip :title="tooltipObj.connect_fee" :html="true"></tooltip>
                      </label>
                      <div class="form-field col-md-8 col-xs-12">
                        <div class="row">
                          <div class="col-xs-6">
                            <input type="number"
                                   min="0"
                                   max="99999"
                                   class="hz-input-default hz-input-md"
                                   @input="toFixed('connect_fee')"
                                   v-model="data.extend_profit_condition.connect_fee"
                            >
                            <span class="hz-unit">백만원</span>
                          </div>
                          <div class="col-xs-6">
                            <button type="button" class="hz-btn-default hz-btn-md" @click="openConnectFeeCalculator">계산기</button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row form-group">
                      <label class="col-md-4 col-xs-12">착수금</label>
                      <div class="form-field col-md-8 col-xs-12">
                        <input type="number" class="hz-input-default hz-input-md"
                               @input="toFixed('retaining_fee')"
                               v-model="data.extend_profit_condition.retaining_fee">
                        <span class="hz-unit">백만원</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="row form-group">
                      <label class="col-md-4 col-xs-12">
                        연간 유지관리비
                        <tooltip class="condition-tooltip" :title="tooltipObj.om_fee" :html="true"></tooltip>
                      </label>
                      <div class="form-field col-md-8 col-xs-12">
                        <div class="row">
                          <div class="col-xs-6">
                            <input type="number"
                                   class="hz-input-default hz-input-md"
                                   @input="toFixed('om_fee')"
                                   v-model="data.extend_profit_condition.om_fee"
                            >
                            <span class="hz-unit">백만원</span>
                          </div>
                          <div class="col-xs-6">
                            <button type="button" class="hz-btn-default hz-btn-md" @click="calcOmFee">자동계산</button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row form-group">
                      <label class="col-md-4 col-xs-12">대출수수료</label>
                      <div class="form-field col-md-8 col-xs-12">
                        <input type="number" class="hz-input-default hz-input-md"
                               @input="toFixed('loan_commission_fee')"
                               v-model="data.extend_profit_condition.loan_commission_fee">
                        <span class="hz-unit">백만원</span>
                      </div>
                    </div>
                    <div class="row form-group">
                      <label class="col-md-4 col-xs-12">종합보험료</label>
                      <div class="form-field col-md-8 col-xs-12">
                        <input type="number" class="hz-input-default hz-input-md"
                               @input="toFixed('insurance_fee')"
                               v-model="data.extend_profit_condition.insurance_fee">
                        <span class="hz-unit">백만원</span>
                      </div>
                    </div>
                    <div class="row form-group">
                      <label class="col-md-4 col-xs-12">토지비</label>
                      <div class="form-field col-md-8 col-xs-12">
                        <input type="number" class="hz-input-default hz-input-md"
                               @input="toFixed('land_fee')"
                               v-model="data.extend_profit_condition.land_fee">
                        <span class="hz-unit">백만원</span>
                      </div>
                    </div>
                    <div class="row form-group">
                      <label class="col-md-4 col-xs-12">기타사업비<tooltip :title="tooltipObj.business_etc_fee"></tooltip></label>
                      <div class="form-field col-md-8 col-xs-12">
                        <input type="number" class="hz-input-default hz-input-md"
                               @input="toFixed('business_etc_fee')"
                               v-model="data.extend_profit_condition.business_etc_fee">
                        <span class="hz-unit">백만원</span>
                      </div>
                    </div>
                    <div class="row form-group">
                      <label class="col-md-4 col-xs-12">사용료/임차료</label>
                      <div class="form-field col-md-8 col-xs-12">
                        <input type="number" class="hz-input-default hz-input-md"
                               @input="toFixed('usage_fee')"
                               v-model="data.extend_profit_condition.usage_fee">
                        <span class="hz-unit">백만원</span>
                      </div>
                    </div>
                    <div class="row form-group related-field">
                      <label class="col-md-4 col-xs-12">총 사업비<tooltip :title="tooltipObj.business_total_cost"></tooltip></label>
                      <div class="form-field col-md-8 col-xs-12">
                        <input type="number" class="hz-input-default hz-input-md"  readonly="true"
                               @input="toFixed('business_total_cost')"
                               v-model="data.extend_profit_condition.business_total_cost">
                        <span class="hz-unit">백만원</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-show="data.extend_index.profit_option" class="row margin-bottom-48">
                  <div class="col-md-6">
                    <h5 class="card-category">금융조건</h5>
                    <div class="row form-group">
                      <label class="col-md-4 col-xs-12">사업자유형<tooltip :title="tooltipObj.business_type"></tooltip></label>
                      <div class="form-field col-md-8 col-xs-12">
                        <drop-down-list :options="[{name: '개인사업자', value: 'IDV'}, {name: '법인사업자', value: 'CRP'}]"
                                        :label="''" :size="'hz-dropdownlist-md'" v-model="data.extend_profit_condition.business_type" @input=""></drop-down-list>
                      </div>
                    </div>
                    <div class="row form-group">
                      <label class="col-md-4 col-xs-12">대출비율1<tooltip :title="tooltipObj.loan_rate"></tooltip></label>
                      <div class="form-field col-md-8 col-xs-12">
                        <div class="row">
                          <div class="col-xs-6" style="padding: 0 4px 0 0;">
                            <input type="number"
                                   class="hz-input-default hz-input-md"
                                   min="0"
                                   max="100"
                                   @input="toFixed('loan_rate')"
                                   v-model="data.extend_profit_condition.loan_rate"
                            >
                            <span class="hz-unit">%</span>
                          </div>
                          <div class="col-xs-6" style="padding: 0 0 0 4px;">
                            <input type="number"
                                   class="hz-input-default hz-input-md"
                                   min="0"
                                   max="99999"
                                   @input="toFixed('loan')"
                                   v-model="data.extend_profit_condition.loan"
                            >
                            <span class="hz-unit">백만원</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row form-group">
                      <label class="col-md-4 col-xs-12">대출비율2<tooltip :title="tooltipObj.loan_rate2"></tooltip></label>
                      <div class="form-field col-md-8 col-xs-12">
                        <div class="row">
                          <div class="col-xs-6" style="padding: 0 4px 0 0;">
                            <input type="number"
                                   class="hz-input-default hz-input-md"
                                   min="0"
                                   max="100"
                                   @input="toFixed('loan_rate2')"
                                   v-model="data.extend_profit_condition.loan_rate2"
                            >
                            <span class="hz-unit">%</span>
                          </div>
                          <div class="col-xs-6" style="padding: 0 0 0 4px;">
                            <input type="number"
                                   class="hz-input-default hz-input-md"
                                   min="0"
                                   max="99999"
                                   @input="toFixed('loan2')"
                                   v-model="data.extend_profit_condition.loan2"
                            >
                            <span class="hz-unit">백만원</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row form-group">
                      <label class="col-md-4 col-xs-12">대출금리</label>
                      <div class="form-field col-md-8 col-xs-12">
                        <input type="number"
                               class="hz-input-default hz-input-md"
                               min="0"
                               max="100"
                               @input="toFixed('interest_rate')"
                               v-model="data.extend_profit_condition.interest_rate"
                        >
                        <span class="hz-unit">%</span>
                      </div>
                    </div>
                    <div class="row form-group">
                      <label class="col-md-4 col-xs-12">거치기간</label>
                      <div class="form-field col-md-8 col-xs-12">
                        <input type="number"
                               class="hz-input-default hz-input-md"
                               min="0"
                               max="100"
                               @input="toFixed('loan_period')"
                               v-model="data.extend_profit_condition.loan_period"
                        >
                        <span class="hz-unit">년</span>
                      </div>
                    </div>
                    <div class="row form-group">
                      <label class="col-md-4 col-xs-12">상환기간<tooltip :title="tooltipObj.redemption_period"></tooltip></label>
                      <div class="form-field col-md-8 col-xs-12">
                        <input type="number"
                               class="hz-input-default hz-input-md"
                               min="0"
                               max="100"
                               @input="toFixed('redemption_period')"
                               v-model="data.extend_profit_condition.redemption_period"
                        >
                        <span class="hz-unit">년</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <h5 class="card-category">판매조건</h5>
                    <div class="row form-group">
                      <label class="col-md-4 col-xs-12">
                        SMP 기간
                        <tooltip :title="tooltipObj.business_period" :html="true"></tooltip>
                      </label>
                      <div class="form-field col-md-8 col-xs-12">
                        <input type="number"
                               class="hz-input-default hz-input-md"
                               min="1"
                               max="25"
                               v-model="data.extend_profit_condition.business_period"
                        >
                        <span class="hz-unit">년</span>
                      </div>
                    </div>
                    <div class="row form-group">
                      <label class="col-md-4 col-xs-12">SMP 단가<tooltip :title="tooltipObj.smp_price" :html="true"></tooltip></label>
                      <div class="form-field col-md-8 col-xs-12">
                        <input type="number"
                               ref="smpPriceField"
                               id="smpPrice"
                               class="hz-input-default hz-input-md"
                               min="0"
                               max="99999"
                               @input="toFixed('smp_price')"
                               @keyup="isEditingSmpPrice = true"
                               v-model="data.extend_profit_condition.smp_price"
                        >
                        <span class="hz-unit">원/kWh</span>
                        <div class="recent-input-price" v-show="isShowRecentSmpPrice">
                          <ul>
                            <li v-for="smpPrice in recentSmpPrice" @click="selectPriceItem('smp', smpPrice)">
                              <span class="price">{{ smpPrice }}</span>
                              <span class="hz-unit">원/kWh</span>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div class="row form-group">
                      <label class="col-md-4 col-xs-12">
                        REC 기간
                        <tooltip :title="tooltipObj.rec_period" :html="true"></tooltip>
                      </label>
                      <div class="form-field col-md-8 col-xs-12">
                        <input type="number"
                               class="hz-input-default hz-input-md"
                               min="0"
                               max="25"
                               v-model="data.extend_profit_condition.rec_period"
                        >
                        <span class="hz-unit">년</span>
                      </div>
                    </div>
                    <div class="row form-group">
                      <label class="col-md-4 col-xs-12">REC 단가<tooltip :title="tooltipObj.rec_price" :html="true"></tooltip></label>
                      <div class="form-field col-md-8 col-xs-12">
                        <input type="number"
                               ref="recPriceField"
                               id="recPrice"
                               class="hz-input-default hz-input-md"
                               min="0"
                               max="99999"
                               @keyup="isEditingRecPrice = true"
                               @input="toFixed('rec_price')"
                               v-model="data.extend_profit_condition.rec_price"
                        >
                        <span class="hz-unit">원/kWh</span>
                        <div class="recent-input-price" v-show="isShowRecentRecPrice">
                          <ul>
                            <li v-for="recPrice in recentRecPrice" @click="selectPriceItem('rec', recPrice)">
                              <span class="price">{{ recPrice }}</span>
                              <span class="hz-unit">원/kWh</span>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div class="row form-group related-field">
                      <label class="col-md-4 col-xs-12">REC 가중치<tooltip :title="'용량과 사업지유형을 기준으로 자동 계산됩니다.'"></tooltip></label>
                      <div class="form-field col-md-8 col-xs-12">
                        <input type="number" class="hz-input-default hz-input-md"
                               @input="toFixed('rec_weight')"
                               v-model="data.extend_profit_condition.rec_weight">
                        <span class="hz-unit">배</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row margin-bottom-48">
                  <h5 class="card-category">설치조건</h5>
                  <div class="col-md-6">
                    <div class="row form-group">
                      <label class="col-md-4 col-xs-12">발전시간1<tooltip :title="tooltipObj.average_generate_time"></tooltip></label>
                      <div class="form-field col-md-8 col-xs-12">
                        <div class="row">
                          <div class="col-xs-6 padding-0">
                            <input type="number"
                                   class="hz-input-default hz-input-md"
                                   min="0"
                                   max="24"
                                   :readonly="requestState.analysis.state === 'load'"
                                   @input="toFixed('average_generate_time')"
                                   v-model="data.extend_profit_condition.average_generate_time"
                            >
                            <span class="hz-unit">시간/일</span>
                          </div>
                          <div class="col-xs-6 padding-0">
                            <button type="button"
                                    class="hz-btn-default hz-btn-md pull-left"
                                    @click="getAnalysisInfo()">자동계산</button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row form-group">
                      <label class="col-md-4 col-xs-12">발전시간2<tooltip :title="tooltipObj.average_generate_time2"></tooltip></label>
                      <div class="form-field col-md-8 col-xs-12">
                        <input type="number"
                               class="hz-input-default hz-input-md"
                               min="0"
                               max="24"
                               @input="toFixed('average_generate_time2')"
                               v-model="data.extend_profit_condition.average_generate_time2"
                        >
                        <span class="hz-unit">시간/일</span>
                      </div>
                    </div>
                    <div class="row form-group">
                      <label class="col-md-4 col-xs-12">음영손실<tooltip :title="tooltipObj.shade_lose"></tooltip></label>
                      <div class="form-field col-md-8 col-xs-12">
                        <input type="number"
                               class="hz-input-default hz-input-md"
                               min="0"
                               max="100"
                               @input="toFixed('shade_lose')"
                               v-model="data.extend_profit_condition.shade_lose">
                        <span class="hz-unit">%</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="row form-group">
                      <label class="col-md-4 col-xs-12">향<tooltip :title="tooltipObj.aspect"></tooltip></label>
                      <div class="form-field col-md-8 col-xs-12">
                        <input type="number"
                               class="hz-input-default hz-input-md"
                               min="0"
                               max="360"
                               @input="toFixed('aspect')"
                               v-model="data.extend_profit_condition.aspect">
                        <span class="hz-unit">도</span>
                      </div>
                    </div>
                    <div class="row form-group">
                      <label class="col-md-4 col-xs-12">경사각<tooltip :title="tooltipObj.tilt_angle"></tooltip></label>
                      <div class="form-field col-md-8 col-xs-12">
                        <input type="number"
                               class="hz-input-default hz-input-md"
                               min="0"
                               max="90"
                               @input="toFixed('tilt_angle')"
                               v-model="data.extend_profit_condition.tilt_angle">
                        <span class="hz-unit">도</span>
                      </div>
                    </div>
                    <div class="row form-group">
                      <label class="col-md-4 col-xs-12">운휴일<tooltip :title="tooltipObj.suspension_date_cnt"></tooltip></label>
                      <div class="form-field col-md-8 col-xs-12">
                        <input type="number"
                               class="hz-input-default hz-input-md"
                               min="0"
                               max="365"
                               @input="toFixed('suspension_date_cnt')"
                               v-model="data.extend_profit_condition.suspension_date_cnt">
                        <span class="hz-unit">일</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card">
            <div id="etcInfo" class="card-header">
              <a href="#etcContent" data-toggle="collapse" aria-expanded="true" aria-controls="etcContent">기타정보<i class="glyphicon glyphicon-triangle-bottom pull-right"></i></a>
            </div>
            <div id="etcContent" class="collapse show in" aria-labelledby="etcInfo">
              <div class="card-body">
                <div class="row">
                  <div class="col-md-6">
                    <h5 class="card-category">회사정보</h5>
                    <div class="row form-group">
                      <label class="col-md-4 col-xs-12">담당자명</label>
                      <div class="form-field col-md-8 col-xs-12">
                        <input type="text" class="hz-input-default hz-input-md" maxlength="40" placeholder="담당자명을 입력하세요." v-model="data.extend_user">
                      </div>
                    </div>
                    <div v-show="data.extend_index.company_info" class="row form-group">
                      <label class="col-md-4 col-xs-12">담당자 연락처</label>
                      <div class="form-field col-md-8 col-xs-12">
                        <input-phone class="hz-input-default hz-input-md" :placeholder="'담당자 연락처를 입력하세요.'" v-model="data.extend_contact"></input-phone>
                      </div>
                    </div>
                    <div v-show="data.extend_index.company_info" class="row form-group">
                      <label class="col-md-4 col-xs-12">담당자 이메일</label>
                      <div class="form-field col-md-8 col-xs-12">
                        <input type="text" class="hz-input-default hz-input-md" maxlength="40" placeholder="'담당자 이메일을 입력하세요.'" v-model="data.extend_email">
                      </div>
                    </div>
                    <div v-show="data.extend_index.company_info && !data.extend_index.intro_comp" class="row form-group">
                      <label class="col-md-4 col-xs-12">회사소개서</label>
                      <div v-if="data.resume_file" class="form-field input-md-wrap col-md-8 col-xs-12">
                        <div class="row">
                          <div class="col-xs-8 padding-0">
                            <input type="text"
                                   class="hz-input-default hz-input-md introduction-field"
                                   readonly="readonly"
                                   @click="openSite(data.resume_file[0].datafile, '_blank', false)"
                                   :value="data.resume_file[0].origin_name">
                          </div>
                          <div class="col-xs-4 padding-0">
                            <button type="button"
                                    class="hz-btn-default hz-btn-md pull-left"
                                    style="width: 100%; line-height: 30px; border-left: none;"
                                    @click="showModal('introductionModal')">파일찾기</button>
                          </div>
                        </div>
                      </div>
                      <div v-else class="form-field input-md-wrap col-md-8 col-xs-12">
                        <button type="button"
                                class="hz-btn-default hz-btn-md pull-left"
                                style="width: 100%; line-height: 30px;"
                                @click="showModal('introductionModal')">파일찾기</button>
                      </div>
                      <div class="col-md-offset-4 col-md-8 col-xs-12">
                        <p class="explain-text" style="margin: 2px 0 16px 0;">보고서에 회사소개서가 출력됩니다.</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <h5 class="card-category">첨부파일</h5>
                    <div v-show="data.extend_index.spot_photo_file" class="row form-group">
                      <label class="col-md-4 col-xs-12">현장사진<tooltip :title="tooltipObj.spot_photo_file"></tooltip></label>
                      <div class="form-field input-md-wrap col-md-8 col-xs-12">
                        <input-file :auth="true"
                                    :multiple="true"
                                    :limited="8"
                                    :preview="true"
                                    :rotate="true"
                                    :options="fileUploadOptions"
                                    :saveUrl="fileSaveUrl + '?category=spot_photo_file'"
                                    :removeUrl="fileRemoveUrl"
                                    v-model="data.spot_photo_file"></input-file>
                      </div>
                    </div>
                    <div v-show="data.extend_index.plot_plan_file" class="row form-group">
                      <label class="col-md-4 col-xs-12">배치도</label>
                      <div class="form-field input-md-wrap col-md-8 col-xs-12">
                        <input-file :auth="true"
                                    :preview="true"
                                    :rotate="true"
                                    :options="fileUploadOptions"
                                    :saveUrl="fileSaveUrl + '?category=plot_plan_file'"
                                    :removeUrl="fileRemoveUrl"
                                    v-model="data.plot_plan_file"></input-file>
                      </div>
                    </div>
                    <div v-show="data.extend_index.business_cost_file" class="row form-group">
                      <label class="col-md-4 col-xs-12">견적서</label>
                      <div class="form-field input-md-wrap col-md-8 col-xs-12">
                        <input-file :auth="true"
                                    :preview="true"
                                    :rotate="true"
                                    :options="fileUploadOptions"
                                    :saveUrl="fileSaveUrl + '?category=business_cost_file'"
                                    :removeUrl="fileRemoveUrl"
                                    v-model="data.business_cost_file"></input-file>
                      </div>
                    </div>
                    <div v-show="data.extend_index.schedule_file" class="row form-group">
                      <label class="col-md-4 col-xs-12">추진일정</label>
                      <div class="form-field input-md-wrap col-md-8 col-xs-12">
                        <input-file :auth="true"
                                    :preview="true"
                                    :rotate="true"
                                    :options="fileUploadOptions"
                                    :saveUrl="fileSaveUrl + '?category=schedule_file'"
                                    :removeUrl="fileRemoveUrl"
                                    v-model="data.schedule_file"></input-file>
                      </div>
                    </div>
                    <div v-show="data.extend_index.intro_comp"  class="row form-group">
                      <label class="col-md-4 col-xs-12">설치유형</label>
                      <div class="form-field input-md-wrap col-md-8 col-xs-12">
                        <ul v-if="data['reference_file'] && data['reference_file'].length > 0">
                          <!-- 다중 선택 및 추가, 삭제가 자유로운 영역이라 데이터 변동이 심하다.
                          report화면에서 순서대로 출력하기 위해 array 위치를 고정하여 컨트롤한다.
                          미래에 삭제되는 유형이 있다면, 해당 array index는 유지한다.(다른 유형으로 대체하지 않는다.)
                          미래에 추가되는 유형이 있다면, 4번 5번째..로 추가한다. 과거 생성한 보고서의 유형에 대한 데이터 유지 위해 -->
                          <li :class="['review-state-box', 'col-xs-3', { 'review-active': data.reference_file[0].origin_name === '옥상' }]"
                              @click="checkReference('옥상',0)" style="height: 30px; line-height: 30px;">옥상</li>
                          <li :class="['review-state-box', 'col-xs-3', 'border-left-none', { 'review-active':  data.reference_file[1].origin_name === '지붕' }]"
                              @click="checkReference('지붕',1)" style="height: 30px; line-height: 30px;">지붕</li>
                          <li :class="['review-state-box', 'col-xs-3', 'border-left-none', { 'review-active':  data.reference_file[2].origin_name === '주차장' }]"
                              @click="checkReference('주차장',2)" style="height: 30px; line-height: 30px;">주차장</li>
                          <li :class="['review-state-box', 'col-xs-3', 'border-left-none', { 'review-active':  data.reference_file[3].origin_name === '토지' }]"
                              @click="checkReference('토지',3)" style="height: 30px; line-height: 30px;">토지</li>
                        </ul>
                        <!-- <ul v-if="data['reference_file'] && data['reference_file'].length > 0">
                          <li v-for="(file, index) in data['reference_file']" :key="index">
                            {{ file }}
                          </li>
                        </ul> -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="extend-footer">
        <div class="container">
          <div class="row">
            <div class="col-xs-12 text-center">
              <button v-if="!isNewReport && hasAuthReport" type="button" class="hz-btn-default hz-btn-lg" @click="showSaveModal('copy')">다른이름으로 저장</button>
              <button v-if="isNewReport || hasAuthReport" type="button" class="hz-btn-primary hz-btn-lg" @click="showSaveModal('save')">저장 후 미리보기</button>
              <button v-if="!isNewReport && !hasAuthReport" type="button" class="hz-btn-primary hz-btn-lg" @click="openPreview">미리보기</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- API 요청 상태 알림창 -->
    <div class="alert-wrap">
      <alert v-for="request in requestState"
             :key="request.id"
             :id="request.id"
             :text="request.text"
             :state="request.state"
             @reload="reLoadData"></alert>
    </div>

    <!-- 문의하기 FAB -->
    <div class="contact-fab" style="position: relative;">
      <a class="fab fab-text" @click.prevent="$refs.contactModal.show()">문의<br>하기</a>
    </div>

    <!-- 조례정보 모달 -->
    <div class="modal fade hz-modal-default" id="examineModal" tabindex="-1" role="dialog" aria-labelledby="examineModalLabel'" aria-hidden="true">
      <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="examineModalLabel">조례목록</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row form-group">
              <table class="col-xs-12">
                <tr class="table-header">
                  <th>종류</th>
                  <th>법규명</th>
                  <th>제/개정일</th>
                </tr>
                <tr v-if="data.extend_buji_result.examine.length === 0">
                  <td colspan="3" style="text-align: center;">조회된 정보가 없습니다.</td>
                </tr>
                <tr v-if="data.extend_buji_result.examine.length > 0" class="table-content"
                    v-for="examine in data.extend_buji_result.examine">
                  <td>{{ examine['category'] | nullCheck }}</td>
                  <td>
                    <a href="javascript:void(0)" @click="openSite(examine.link)" v-html="examine.name"></a>
                  </td>
                  <td>{{ examine.rev_date | nullCheck }}</td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 문의하기 모달 -->
    <contact-modal ref="contactModal"></contact-modal>

    <!-- 알림창 -->
    <modal ref="notifyModal" :id="notifyModal.id" :type="notifyModal.type" :title="notifyModal.title"
           :size="notifyModal.size" :fields="notifyModal.fields"></modal>

    <!-- 보고서 저장 창 -->
    <modal ref="saveModal" :id="saveModal.id" :type="saveModal.type" :title="saveModal.title"
           :size="saveModal.size" :fields="saveModal.fields" @submit="submitReport(saveModal.param)" v-model="data"></modal>

    <!-- 회사소개서 등록 알림창 -->
    <modal ref="introductionModal" :id="introductionModal.id" :type="introductionModal.type" :title="introductionModal.title"
           :size="introductionModal.size" :fields="introductionModal.fields" @submit="$router.push({name: 'mypage', query: {id: 'companyIntroduction'}})"></modal>
  </div>
</template>

<script>
  import Loader from 'common/components/Loader'
  import DropDownList from 'common/components/DropDownList'
  import InputFile from 'common/components/InputFile'
  import InputPhone from 'common/components/InputPhone'
  import Tooltip from 'common/components/Tooltip'
  import Modal from 'common/components/Modal'
  import ExtendIndex from '@/components/ExtendIndex'
  import Alert from '@/components/Alert'
  import ContactModal from '@/components/ContactModal'
  import api from '@/api/index'
  import eventHub from '@/shared/EventHub'
  import conditionTooltip from '@/assets/js/condition-tooltip.js'
  import { mapActions, mapGetters } from 'vuex'

  export default {
    name: 'extend-report',
    components: {
      Loader,
      DropDownList,
      InputFile,
      InputPhone,
      Tooltip,
      Modal,
      ContactModal,
      Alert,
      ExtendIndex
    },
    data () {
      return {
        isRender: false,
        loaderActive: false,
        indexActive: false,
        titleEdit: false,
        isFocusSmpPrice: false,
        isEditingSmpPrice: false,
        isFocusRecPrice: false,
        isEditingRecPrice: false,
        data: {
          project_name: '',
          address: [],
          extend_status: 'C',
          extend_grade: '미정',
          extend_examine: '',
          extend_memo: '',
          extend_buji_result: {
            arch: [],
            electronic: [],
            electronic_phones: [],
            examine: [],
            examine_phones: [],
            jibun: {},
            jibunList: [],
            landInfo: [],
            landInfoSum: [],
            map: [],
            restrict: [],
            selectJibun: ''
          },
          extend_profit_condition: {
            expect_capacity: 0,
            plant_type: 'BD',
            unit_price: 0,
            install_fee: 0,
            connect_fee: 0,
            retaining_fee: 0,
            om_fee: 0,
            loan_commission_fee: 0,
            insurance_fee: 0,
            land_fee: 0,
            business_etc_fee: 0,
            business_total_cost: 0,
            usage_fee: 0,
            smp_price: 0,
            rec_price: 0,
            business_period: 20,
            rec_period: 20,
            rec_weight: 0,
            is_hz_algorithm: true,
            average_generate_time: 3.5,
            average_generate_time2: 3.7,
            aspect: 180,
            tilt_angle: 25,
            shade_lose: 0,
            suspension_date_cnt: 0,
            business_type: 'IDV',
            loan_rate: 0,
            loan_rate2: 0,
            loan: 0,
            loan2: 0,
            interest_rate: 0,
            loan_period: 0,
            redemption_period: 0
          },
          extend_profit_result: {
            analysis: {},
            profit: []
          },
          extend_index: {
            plant_analysis: true,
            plant_summary: true,
            spot_photo_file: true,
            review_result: true,
            power_analysis: true,
            apparatus_plan: true,
            module: true,
            inverter: true,
            plot_plan_file: true,
            business_profit: true,
            business_cost_file: true,
            profit_option: true,
            schedule_file: true,
            reference_file: true,
            company_info: true,
            supplement: true,
            intro_comp: false
          },
          master_module: [],
          master_inverter: [],
          spot_photo_file: [],
          plot_plan_file: [],
          business_cost_file: [],
          schedule_file: [],
          reference_file: [],
          resume_file: []
        },
        requestState: {
          map: { id: 'map', state: '', text: '' },
          land: { id: 'land', state: '', text: '' },
          restrict: { id: 'restrict', state: '', text: '' },
          arch: { id: 'arch', state: '', text: '' },
          examine: { id: 'examine', state: '', text: '' },
          electronic: { id: 'electronic', state: '', text: '' },
          phone: { id: 'phone', state: '', text: '' },
          analysis: { id: 'analysis', state: '', text: '' },
          profit: { id: 'profit', state: '', text: '' }
        },
        selectModule: '',
        selectInverter: '',
        dataUrl: location.protocol + '//' + location.hostname.replace('biz', 'api'),
        tooltipObj: conditionTooltip,
        notifyModal: {
          id: 'notifyModal',
          type: 'alert',
          title: '알림',
          size: 'modal-sm',
          fields: [
            {
              type: 'message',
              message: [],
              class: 'text-center'
            }
          ]
        },
        saveModal: {
          id: 'saveModal',
          type: 'confirm',
          title: '저장',
          param: '',
          size: 'modal-sm',
          fields: []
        },
        introductionModal: {
          id: 'introductionModal',
          type: 'confirm',
          title: '알림',
          size: 'modal-sm',
          fields: [
            {
              type: 'message',
              message: ['마이페이지에서 업로드 할 수 있습니다.', '작성중인 내용을 저장하고 이동하시겠습니까?'],
              class: 'text-center'
            }
          ]
        },
        companyProfileOptions: {
          validation: {
            allowedExtensions: ['.pdf', '.jpg', '.jpeg', '.png'],
            maxFileSize: 5 * 1024 * 1024,
            minFileSize: 0
          }
        },
        fileUploadOptions: {
          validation: {
            allowedExtensions: ['.jpg', '.jpeg', '.png'],
            maxFileSize: 5 * 1024 * 1024,
            minFileSize: 0
          }
        },
        fileSaveUrl: location.protocol + '//' + location.hostname.replace('biz', 'api') + '/biz/file/',
        fileRemoveUrl: location.protocol + '//' + location.hostname.replace('biz', 'api') + '/biz/file/delete/'
      }
    },
    computed: {
      ...mapGetters({
        reportData: 'reportData',
        user: 'user',
        condition: 'condition',
        isPaidMember: 'isPaidMember',
        recentSmpPrice: 'recent_smp_price',
        recentRecPrice: 'recent_rec_price'
      }),
      addressTag () {
        const address = this.data.address
        const len = address.length
        let text = address[0]

        if (len > 1) {
          const addressCnt = len - 1
          text += ` 외 ${addressCnt} 곳`
        }

        return text
      },
      hasAuthReport () {
        return this.isWriter && this.isPaidMember
      },
      isShowRecentSmpPrice () {
        const hasRecentPriceItems = this.recentSmpPrice.length > 0

        return hasRecentPriceItems && this.isFocusSmpPrice && !this.isEditingSmpPrice
      },
      isShowRecentRecPrice () {
        const hasRecentPriceItems = this.recentRecPrice.length > 0

        return hasRecentPriceItems && this.isFocusRecPrice && !this.isEditingRecPrice
      },
      isNewReport () {
        // 신규 보고서인지 구분한다. (보고서 ID 유무)
        const data = this.data
        const isNewReport = typeof data.reg_by === 'undefined' || data.extend_status === 'C'

        return isNewReport
      },
      isWriter () {
        // 보고서 작성자와 로그인한 사용자가 동일한지 확인한다.
        return this.data.reg_by === this.user.id
      },
      stateTagClass () {
        // 추진가능성 태그 클래스 할당
        const grade = this.data.extend_grade
        const stateTag = {
          '가능': 'possible-tag',
          '불가': 'impossible-tag',
          '보류': 'hold-tag'
        }

        return stateTag[grade]
      }
    },
    watch: {
      'user': {
        handler (val) {
          /**
           * 페이지에 들어온 상태에서 새로고침 시
           * 페이지 초기화 시점보다 유저정보 업데이트 시점이 느리다.
           * 따라서 watch를 통해 user 정보가 업데이트 되는 시점에 권한체크 로직을 수행시킨다.
           */

          if (typeof val.id !== 'undefined') {
            this.$store.dispatch('checkAccessMenu').then(() => {
              this.init()
            })
          }
        }
      },
      'isRender': {
        handler (bool) {
          if (bool) {
            this.$nextTick(() => {
              this.addEventListenerPriceInput()
            })
          }
        }
      },
      'data.extend_profit_condition.expect_capacity': {
        handler () {
          if (this.isRender) {
            this.calcInstallFee()
            this.getRecWeight()
          }
        }
      },
      'data.extend_profit_condition.unit_price': {
        handler () {
          if (this.isRender) {
            this.calcInstallFee()
          }
        }
      },
      'data.extend_profit_condition.install_fee': {
        handler () {
          if (this.isRender) {
            this.calcTotalCost()
          }
        }
      },
      'data.extend_profit_condition.business_etc_fee': {
        handler () {
          if (this.isRender) {
            this.calcTotalCost()
          }
        }
      },
      'data.extend_profit_condition.connect_fee': {
        handler () {
          if (this.isRender) {
            this.calcTotalCost()
          }
        }
      },
      'data.extend_profit_condition.retaining_fee': {
        handler () {
          if (this.isRender) {
            this.calcTotalCost()
          }
        }
      },
      'data.extend_profit_condition.land_fee': {
        handler () {
          if (this.isRender) {
            this.calcTotalCost()
          }
        }
      },
      'data.extend_profit_condition.loan_commission_fee': {
        handler () {
          if (this.isRender) {
            this.calcTotalCost()
          }
        }
      },
      'data.extend_profit_condition.business_total_cost': {
        handler () {
          // 대출비율이 있을경우, 총 사업비 변경에 따른 대출금액 계산
          if (this.isRender && this.data.extend_profit_condition.loan_rate > 0) {
            this.calcLoan()
          }
        }
      },
      'data.extend_profit_condition.loan_rate': {
        handler () {
          if (this.isRender) {
            this.calcLoan()
          }
        }
      },
      'data.extend_profit_condition.loan_rate2': {
        handler () {
          if (this.isRender) {
            this.calcLoan()
          }
        }
      },
      'data.extend_profit_condition.business_period': {
        handler: _.debounce(function (val) {
          if (this.isRender) {
            this.data.extend_profit_condition.business_period = Math.min(Math.max(1, val), 25)
          }
        }, 500)
      },
      'data.extend_profit_condition.rec_period': {
        handler: _.debounce(function (val) {
          if (this.isRender) {
            this.data.extend_profit_condition.rec_period = Math.min(Math.max(0, val), 25)
          }
        }, 500)
      }
    },
    methods: {
      ...mapActions([
        'setReportData',
        'showToastMessage',
        'setRecentInputPrice',
        'getPricingInfo'
      ]),
      init () {
        /**
         *  페이지 초기화 함수입니다.
         *  페이지 URL Parameter에 ID 여부에 따라 신규검토, 저장된 검토인지를 구분합니다.
         *  신규검토 일 경우, 해당 주소지를 기준으로 데이터를 호출합니다.
         *  저장된 검토 일 경우, ID 값으로 저장된 내용을 호출합니다.
         */

        const vm = this
        const params = vm.$route.params

        // 보고서 ID 또는 검토주소가 없을 경우, 원클릭 인데스 페이지로 redirect
        const isEmpty = $.isEmptyObject(params)
        if (isEmpty) {
          vm.$router.push({name: 'extend'})
          return false
        }

        // 로그인 한 사용자가 해줌 직원인지 일반 사용자인지를 구분한다.
        const user = vm.user
        if (user.hasOwnProperty('auth_level')) {
          vm.data.extend_index.intro_comp = user.auth_level === '90'
        }

        // 보고서 ID 여부로 저장, 신규 보고서 구분
        const isLoad = params.hasOwnProperty('id')
        if (isLoad) {
          vm.getReport(params.id)
        } else {
          vm.initNewReport(params.address.split('|'))
        }
      },
      initNewReport (address) {
        // 현재 페이지에 데이터와 저장된 데이터를 병합하여 데이터를 초기화 해준다.
        const data = this.data
        const user = this.user
        const userCondition = this.condition.excondition
        const reportCondition = this.extend_profit_condition

        // 데이터 초기화
        const dataObj = {
          project_name: address[0],
          address: address,
          resume_file: user.resume_file,
          extend_user: user.pic_name,
          extend_contact: user.pic_contact,
          extend_email: user.pic_email,
          extend_profit_condition: Object.assign({}, reportCondition, userCondition),
          reference_file: [
            { 'origin_name': '', 'datafile': '' },
            { 'origin_name': '', 'datafile': '' },
            { 'origin_name': '', 'datafile': '' },
            { 'origin_name': '', 'datafile': '' }
          ]
        }

        // 현재 데이터와 가공된 데이터를 병합한다.
        this.data = Object.assign({}, data, dataObj)

        // 화면 렌더
        this.isRender = true

        // 스크린 사이즈가 PC 일 경우(1200px 이상), 수익조건 메뉴창을 연다.
        this.indexActive = this.checkScreenWidth()

        this.$nextTick(() => {
          // 데이터 요청
          this.getMapInfo()
          this.getLandArchInfo()
          this.getRestrictInfo()
          this.getExamineInfo()
          this.getJibunList()
          this.getPhoneInfo()
        })
      },
      initLoadReport (response) {
        // 저장된 보고서 일 경우 실행
        const vm = this
        const data = vm.data
        const user = vm.user
        let loadData = response
        let mergeData = {}

        // 회사소개서, 주소 초기화
        loadData.resume_file = user.resume_file
        loadData.address = loadData.address.split(',')

        // 원클릭에 의해 생성된 보고서에 경우 인덱스 정보를 가지고 있지 않으므로 값 유무를 통해 데이터 Set
        loadData.extend_index = $.isEmptyObject(loadData.extend_index) ? data.extend_index : loadData.extend_index

        // 현재 페이지 데이터와 저장된 데이터를 병합한다.
        mergeData = Object.assign({}, data, loadData)

        // 원클릭 사업검토에서 프리미이엄 보고서 생성 이벤트에 의해 이동한 경우, 전달받은 데이터를 업데이트한다.
        if (vm.$route.params.send) {
          mergeData = Object.assign({}, mergeData, vm.reportData)
        }

        // 병합된 데이터를 페이지에 초기화 해준다.
        vm.data = mergeData

        // 과거 report는 빈 배열이거나 null인 레포트가 있다. 과거 report를 열어(load) 편집화면에 진입하더라도 설치유형을 선택하도록 해주자
        if (!vm.data['reference_file'] || vm.data['reference_file'].length === 0) {
          // 초기화 로직
          vm.data['reference_file'] = [
            { 'origin_name': '', 'datafile': '' },
            { 'origin_name': '', 'datafile': '' },
            { 'origin_name': '', 'datafile': '' },
            { 'origin_name': '', 'datafile': '' }
          ]
        }

        vm.$nextTick(() => {
          // 플래그 초기화
          vm.isRender = true
          vm.loaderActive = false

          // 보고서 미리보기 옵션이 활성화 되었을 경우, 미리보기 창을 연다.
          if (vm.$route.params.preview) vm.openPreview()

          // 스크린 사이즈가 PC 일 경우(1200px 이상), 수익조건 메뉴창을 연다.
          vm.indexActive = vm.checkScreenWidth()

          // 저장된 데이터 상태에 따른 API 요청 상태를 초기화 해준다.
          vm.initRequestState(vm.data)
        })
      },
      initRequestState (data) {
        // 저장된 보고서에 경우, 각 데이터별 유무에 따라 요청 상태를 초기화 한다.
        const bujiData = data.extend_buji_result
        const hasMapData = bujiData.map.length > 0
        const hasLandData = bujiData.landInfo.length > 0
        const hasRestrictData = bujiData.restrict.length > 0
        const hasArchData = bujiData.arch.length > 0
        const hasExamineData = bujiData.examine.length > 0
        const hasElectronicData = bujiData.electronic.length > 0
        const hasAnalysisData = !$.isEmptyObject(data.extend_profit_result.analysis)
        const hasProfitData = data.extend_profit_result.profit.length > 0

        this.requestState = {
          map: { id: 'map', state: hasMapData ? 'success' : 'empty', text: '지도정보 결과없음' },
          land: { id: 'land', state: hasLandData ? 'success' : 'empty', text: '토지정보 결과없음' },
          restrict: { id: 'restrict', state: hasRestrictData ? 'success' : 'empty', text: '개발행위제한정보 결과없음' },
          arch: { id: 'arch', state: hasArchData ? 'success' : 'empty', text: '건물정보 결과없음' },
          examine: { id: 'examine', state: hasExamineData ? 'success' : 'empty', text: '조례정보 결과없음' },
          electronic: { id: 'electronic', state: hasElectronicData ? 'success' : 'empty', text: '전력계통정보 결과없음' },
          phone: { id: 'phone', state: 'success', text: '관련부서정보 결과없음' },
          analysis: { id: 'analysis', state: hasAnalysisData ? 'success' : 'empty', text: hasAnalysisData ? '발전분석 요청성공' : '발전분석 결과없음' },
          profit: { id: 'profit', state: hasProfitData ? 'success' : 'empty', text: hasProfitData ? '수익분석 요청성공' : '수익분석 결과없음' }
        }
      },
      setRequestState (id = '', state = 'load') {
        // 데이터 요청상태를 분류하는 함수
        const nameObj = {
          map: '지도정보',
          land: '토지정보',
          restrict: '개발행위제한정보',
          arch: '건물정보',
          examine: '조례정보',
          electronic: '전력계통정보',
          phone: '관련부서정보',
          analysis: '발전분석',
          profit: '수익분석'
        }

        const stateObj = {
          load: '요청중',
          success: '요청성공',
          warning: '공공데이터 서버오류',
          error: '요청실패',
          empty: '결과없음'
        }

        // 출력할 문구설정
        const text = `${nameObj[id]} ${stateObj[state]}`

        // 데이터 상태 정보를 업데이트한다.
        this.requestState[id].state = state
        this.requestState[id].text = text
      },
      checkScreenWidth (width = 1199) {
        // 현재 스크린 width를 비교하여 Boolean 값 반환
        return window.innerWidth > width
      },
      checkResponseCode (code) {
        /*
         * API Response 코드를 분류하여 상태를 반환하는 함수입니다.
         * Status 코드가 아니며 비즈해줌네에서 쓰인 응답결과에 대한 코드입니다.
         * 'SC' = 성공, 'RF' = 외부 API 요청 오류, 'ND' = 데이터 없음
         */

        const stateObj = {
          'SC': 'success',
          'RF': 'warning',
          'ND': 'empty'
        }

        return stateObj[code]
      },
      getReport (id) {
        const vm = this

        // 화면 렌더 플래그를 초기화한다. (로더 활성화, 컴포넌트 초기화 등)
        vm.isRender = false

        // 보고서 데이터 불러오기
        api.getReport('E', id, response => {
          if (response.error) {
            // API 호출 실패 시
            console.log('get Report error!', response)
            vm.$router.push({name: 'extend'})
          } else {
            // 페이지 초기화
            vm.initLoadReport(response)
          }
        })
      },
      submitReport (type = 'save') {
        /**
         *  모달창을 통해 보고서 저장여부를 묻고 저장 이벤트가 발생되었을 경우 실행되는 함수입니다.
         *  보고서 저장/수정 - 보고서 복사 두가지 상태로 나뉩니다.
         *  'save', 'capy' 타입으로 구분합니다.
         *  각 타입에 맞게 정의된 보고서 저장 역할을 실행하는 함수를 호출합니다.
         */

        if (type === 'save') {
          this.saveReport()

          // 입력된 SMP, REC 가격을 로컬 스토리지에 저장한다.
          this.setRecentInputPrice({target: 'smp_price', price: this.data.extend_profit_condition.smp_price})
          this.setRecentInputPrice({target: 'rec_price', price: this.data.extend_profit_condition.rec_price})
        } else {
          this.copyReport()
        }
      },
      saveReport () {
        /**
         * 보고서를 저장, 수정하는 함수입니다.
         * 데이터 요청 유무를 통해 실행여부를 결정합니다. (요청중인 데이터가 있을 경우 실행 X)
         * 아래와 같이 동작합니다.
         * 1. 입력된 수익조건을 토대로 수익성 분석 API를 실행합니다.
         * 2. 수익성 분석이 완료되면 보고서 내용을 저장합니다.
         * 3. 보고서 저장이 완료되면 미리보기 화면을 띄웁니다.
         */

        const vm = this
        const condition = vm.data.extend_profit_condition
        const isValidCondition = vm.checkProfitCondition(condition)

        if (isValidCondition) {
          // 수익분석 요청 상태로 변경
          vm.setRequestState('profit', 'load')

          // 보고서 저장 전 입력된 수익조건으로 수익성 분석을 실행한다.
          api.getProfitInfo('E', condition, profitResponse => {
            if (profitResponse.error) {
              // API 요청 실패 시
              vm.setRequestState('profit', 'error')
              console.log('get ProfitInfo error!', profitResponse)
            } else {
              // API 요청 성공 시, 수익분석 결과와 조건을 초기화한다.
              vm.data.extend_profit_result.profit = profitResponse.profit
              vm.data.extend_profit_condition = profitResponse.condition

              // 데이터 상태 초기화
              vm.setRequestState('profit', 'success')

              // 데이터를 이상없이 모두 불러온 경우, 보고서 저장을 실행한다.
              vm.$nextTick(() => {
                // 데이터를 저장 할 수 있는 상태로 가공한다.
                const data = vm.parseSaveData()

                // 로더 활성화
                vm.loaderActive = true

                api.saveReport('E', data, saveResponse => {
                  if (saveResponse.error) {
                    // API 요청 실패 시
                    vm.loaderActive = false
                    if (saveResponse.message) {
                      vm.showToastMessage('보고서 저장실패 : ' + saveResponse.message)
                    } else {
                      vm.showToastMessage('보고서 저장실패')
                    }
                  } else {
                    // 로더 비활성화
                    vm.loaderActive = false

                    // 저장 완료 알림 메세지 출력
                    vm.showToastMessage('보고서 저장완료')

                    // 신규 보고서 생성 일 경우, 할당받은 보고서 id를 URL에 설정해준다.
                    const isNew = data.extend_status !== 'U'
                    if (isNew) {
                      const result = saveResponse.hasOwnProperty('result') ? saveResponse.result : saveResponse
                      vm.initLoadReport(result)
                      vm.$router.push({name: 'extendLoad', params: {id: result.id}})

                      // 사용자 결제정보 업데이트
                      vm.getPricingInfo().catch(error => {
                        vm.showToastMessage('사용자 결제정보 업데이트 실패')
                        console.log('error get Pricing Info!', error)
                      })
                    }

                    // 미리보기창 오픈
                    vm.openPreview()
                  }
                })
              })
            }
          })
        }
      },
      copyReport () {
        /**
         * 보고서를 복사하는 함수입니다.
         * 데이터 요청 유무를 통해 실행여부를 결정합니다. (요청중인 데이터가 있을 경우 실행 X)
         * 아래와 같이 동작합니다.
         * 1. 보고서 저장을 실행합니다.
         * 2. 새로운 보고서 ID를 할당 받습니다.
         * 3. 해당 ID로 보고서 데이터를 요청하고 URL을 수정합니다.
         */

        const vm = this

        // 데이터를 저장 할 수 있는 상태로 가공한다.
        const data = vm.parseSaveData('copy')
        api.saveReport('E', data, saveResponse => {
          if (saveResponse.error) {
            // API 요청 실패 시
            if (saveResponse.message) {
              vm.showToastMessage('보고서 저장실패 : ' + saveResponse.message)
            } else {
              vm.showToastMessage('보고서 저장실패')
            }
          } else {
            const id = saveResponse.id

            // 할당받은 보고서 ID로 데이터 요청
            vm.getReport(id)

            // URL에 ID값을 세팅
            vm.$router.push({name: 'extendLoad', params: {id: id}})

            // 보고서 복사완료 메세지 출력
            vm.showToastMessage('보고서 저장완료')

            // 사용자 결제정보 업데이트
            vm.getPricingInfo().catch(error => {
              vm.showToastMessage('사용자 결제정보 업데이트 실패')
              console.log('error get Pricing Info!', error)
            })
          }
        })
      },
      parseSaveData (type = '') {
        /**
         * 보고서 저장 시 필요한 데이터 형태로 가공하는 함수입니다.
         * key 값만 저장하거나 Object,Array 형태에 데이터를 String 형태로 변환합니다.
         */
        const user = this.user
        let data = $.extend(true, {}, this.data)

        // 로그인 한 사용자가 해줌인지 사용자인지를 구분한다.
        if (user.hasOwnProperty('auth_level')) {
          data.extend_index.intro_comp = user.auth_level === '90'
        }

        // 다른이름으로 저장 시, 현재 data에 ID값과 프로젝트명을 초기화 한다
        if (type === 'copy') {
          delete data.id
          data.project_name = this.$refs.saveModal.data.project_name
        }

        // 선택된 인버터목록에 ID값만 가져온다.
        for (let i in data.master_inverter) {
          const inverter = data.master_inverter[i]
          data.master_inverter[i] = inverter.inverter
        }

        // 선택된 모듈목록에 ID값만 가져온다.
        for (let i in data.master_module) {
          const module = data.master_module[i]
          data.master_module[i] = module.module
        }

        // 배열과 JSON 형식에 데이터를 텍스트로 변환하여 저장.
        data.address = data.address.toString()
        data.master_inverter = data.master_inverter.toString()
        data.master_module = data.master_module.toString()
        data.extend_index = JSON.stringify(data.extend_index)
        data.extend_profit_condition = JSON.stringify(data.extend_profit_condition)
        data.extend_buji_result = JSON.stringify(data.extend_buji_result)
        data.extend_profit_result = JSON.stringify(data.extend_profit_result)
        data.spot_photo_file = JSON.stringify(data.spot_photo_file)
        data.plot_plan_file = JSON.stringify(data.plot_plan_file)
        data.business_cost_file = JSON.stringify(data.business_cost_file)
        data.schedule_file = JSON.stringify(data.schedule_file)
        data.reference_file = JSON.stringify(data.reference_file)

        // 가공된 데이터를 반환한다.
        return data
      },
      getMapInfo () {
        const vm = this
        const address = vm.data['address']
        const isLoad = vm.requestState.map.state === 'load'

        // 데이터가 로드중일 경우 알림창을 띄운다.
        if (isLoad) {
          const message = ['지도정보를 요청중입니다.', '요청이 끝난 후 다시 시도해주세요.']
          vm.showNotifyModal(message)
          return false
        } else {
          // API 요청 상태로 변경
          vm.setRequestState('map', 'load')

          // 지도 정보 API 요청
          api.getMapInfo(address, response => {
            if (response.error) {
              // API 호출 실패 시
              vm.setRequestState('map', 'error')
              console.log('get MapInfo error!', response)
            } else {
              const code = response.code

              // API 호출 성공 시, 지도 정보를 담는다.
              if (code === 'SC') {
                vm.data.extend_buji_result['map'] = response.result
              }

              // API 상태처리
              vm.setRequestState('map', vm.checkResponseCode(code))
            }
          })
        }
      },
      getLandArchInfo () {
        // 토지 + 건물정보를 불러온다. (신규검토 일 경우 최초 1회만 호출됨)
        const vm = this
        const address = vm.data['address']

        // 데이터 상태 초기화
        vm.setRequestState('land', 'load')
        vm.setRequestState('arch', 'load')

        // 토지정보 API
        const landInfo = new Promise((resolve, reject) => {
          api.getLandInfo(address + '&report_type=E', response => {
            // error 발생 시
            if (response.error) {
              reject(Error(response))
            } else {
              resolve(response)
            }
          })
        })

        // 건물정보 API
        const archInfo = new Promise((resolve, reject) => {
          api.getArchInfo(address, response => {
            // error 발생 시
            if (response.error) {
              reject(Error(response))
            } else {
              resolve(response)
            }
          })
        })

        // 부지정보와 건물정보 API 요청
        Promise.all([landInfo, archInfo]).then(response => {
          const landCode = response[0].code
          const archCode = response[1].code
          let land = []
          let arch = []
          let capacity = 0
          let type = 'LD'
          let area = 0
          let sumArchAreaP = 0

          // 토지정보 요청에 성공했을 경우
          if (landCode === 'SC') {
            land = response[0].result
            capacity = parseFloat(land.landInfoSum[0].expect_capacity.toFixed(3))
            type = land.landInfoSum[0].plant_type
            area = land['landInfoSum'][0]['sumLndpclArP']

            // 토지정보 초기화
            vm.data.extend_buji_result['landInfo'] = land['landInfo']
            vm.data.extend_buji_result['landInfoSum'] = land['landInfoSum']

            // 검토하는 부지에 임야가 있을 경우, 임야 정보를 노출한다
            const isForest = _.find(land['landInfo'], function (o) { return o.lndcgrCodeNm === '임야' })
            if (typeof isForest !== 'undefined') {
              vm.data.extend_buji_result['forest'] = true
            }
          }

          // 건물정보 요청에 성공했을 경우
          if (archCode === 'SC') {
            arch = response[1].result['arch']
            // 면적(평)
            sumArchAreaP = response[1].result['sumArchAreaP']

            // 사업자 유형 - 건물정보 있고 75평 이상이면 건물 아니면 토지정보에서 넘어온 값으로 넣어준다.
            if (arch.length > 0 && sumArchAreaP >= 75) {
              type = 'BD'
              area = sumArchAreaP
            }

            // 건물정보 초기화
            vm.data.extend_buji_result['arch'] = arch
          }

          // 사업자 유형 - 건물정보 있고 75평 이상이면 건물 아니면 토지정보에서 넘어온 값으로 넣어준다.
          if (arch.length > 0 && sumArchAreaP >= 75) {
            type = 'BD'
            area = sumArchAreaP
          } else {
            area = land['landInfoSum'][0]['sumLndpclArP']
          }

          // 부지유형과 면적에 따른 용량 계산 (용량 - 건물이면 /2.5 아니면 /5)
          if (type === 'BD') {
            capacity = parseFloat((area / 2.5).toFixed(3))
          } else {
            capacity = parseFloat((area / 5.0).toFixed(3))
          }

          // 수익조건에 용량, 부지유형을 넣어준다.
          vm.data.extend_profit_condition['expect_capacity'] = capacity
          vm.data.extend_profit_condition['plant_type'] = type

          // 데이터 상태 초기화
          vm.setRequestState('land', vm.checkResponseCode(landCode))
          vm.setRequestState('arch', vm.checkResponseCode(archCode))

          this.$nextTick(() => {
            this.getRecWeight()
            // 유료회원 일 경우, 발전정보 분석 요청을 실행한다.
            if (this.isPaidMember) {
              vm.getAnalysisInfo(true)
            }
          })
        }).catch(error => {
          // 데이터 상태 초기화
          vm.setRequestState('land', 'error')
          vm.setRequestState('arch', 'error')

          // 발전-수익 분석에 경우, 초기 토지-건물 정보가 없을 경우 유효한 계산을 하지 못하기때문에 API 상태를 에러로 처리한다.
          vm.setRequestState('analysis', 'error')
          vm.setRequestState('profit', 'error')
          console.log('in error!', error)
        })
      },
      getLandInfo () {
        const vm = this
        const address = vm.data['address']
        const isLoad = vm.requestState.land.state === 'load'

        // 데이터가 로드중일 경우 알림창을 띄운다.
        if (isLoad) {
          const message = ['토지정보를 요청중입니다.', '요청이 끝난 후 다시 시도해주세요.']
          vm.showNotifyModal(message)
        } else {
          vm.setRequestState('land', 'load')

          // 토지정보 API 요청
          api.getLandInfo(address + '&report_type=E', response => {
            if (response.error) {
              // API 호출 실패 시
              vm.setRequestState('land', 'error')
              console.log('get LandInfo error!', response)
            } else {
              const code = response.code

              // response code에 따른 상태처리
              if (code === 'SC') {
                const land = response.result

                // 부지정보를 넣어준다.
                vm.data.extend_buji_result['landInfo'] = land['landInfo']
                vm.data.extend_buji_result['landInfoSum'] = land['landInfoSum']

                // 검토하는 부지에 임야가 있을 경우, 임야정보를 노출한다.
                const isForest = _.find(land['landInfo'], function (o) { return o.lndcgrCodeNm === '임야' })
                vm.data.extend_buji_result['forest'] = typeof isForest !== 'undefined'
              }

              // 데이터 상태 초기화
              vm.setRequestState('land', vm.checkResponseCode(code))
            }
          })
        }
      },
      getRestrictInfo () {
        const vm = this
        const address = vm.data['address']
        const isLoad = vm.requestState.restrict.state === 'load'

        // 데이터가 로드중일 경우 알림창을 띄운다.
        if (isLoad) {
          const message = ['개발행위제한정보를 요청중입니다.', '요청이 끝난 후 다시 시도해주세요.']
          vm.showNotifyModal(message)
        } else {
          // 데이터 요청중 상태로 변경
          vm.setRequestState('restrict', 'load')
          // 개발행위제한 API 요청
          api.getRestrictInfo(address, response => {
            if (response.error) {
              // API 호출 실패 시
              vm.setRequestState('restrict', 'error')
              console.log('get restrictInfo error!', response)
            } else {
              const code = response.code

              // API 호출 성공 시, 개발행위제한 정보를 담는다.
              if (code === 'SC') {
                vm.data.extend_buji_result['restrict'] = response.result
              }

              // 데이터 상태 초기화
              vm.setRequestState('restrict', vm.checkResponseCode(code))
            }
          })
        }
      },
      getArchInfo () {
        const vm = this
        const address = vm.data['address']
        const isLoad = vm.requestState.arch.state === 'load'

        // 데이터가 로드중일 경우 알림창을 띄운다.
        if (isLoad) {
          const message = ['건물정보를 요청중입니다.', '요청이 끝난 후 다시 시도해주세요.']
          vm.showNotifyModal(message)
        } else {
          vm.setRequestState('arch', 'load')
          // 개발행위제한 API 요청
          api.getArchInfo(address, response => {
            if (response.error) {
              // API 호출 실패 시
              vm.setRequestState('map', 'error')
              console.log('get archInfo error!', response)
            } else {
              const code = response.code

              // API 호출 성공 시, 건물정보를 담는다.
              if (code === 'SC') {
                vm.data.extend_buji_result['arch'] = response.result['arch']
              }

              // 데이터 상태 초기화
              vm.setRequestState('arch', vm.checkResponseCode(code))
            }
          })
        }
      },
      getExamineInfo () {
        const vm = this
        const address = vm.data['address']
        const isLoad = vm.requestState.examine.state === 'load'

        // 데이터가 로드중일 경우 알림창을 띄운다.
        if (isLoad) {
          const message = ['조례정보를 요청중입니다.', '요청이 끝난 후 다시 시도해주세요.']
          vm.showNotifyModal(message)
        } else {
          vm.setRequestState('examine', 'load')
          // 조례정보 API 요청
          api.getExamineInfo(address, response => {
            if (response.error) {
              // API 요청 실패 시
              vm.setRequestState('examine', 'error')
              console.log('get ExamineInfo error!', response)
            } else {
              const code = response.code

              // API 요청 성공 시, 조례정보를 담는다.
              if (code === 'SC') {
                vm.data.extend_buji_result['examine'] = response.result
              }

              // 데이터 상태 초기화
              vm.setRequestState('examine', vm.checkResponseCode(code))
            }
          })
        }
      },
      getElectronicInfo () {
        const vm = this
        const address = vm.data.address[0]
        const isLoad = vm.requestState.electronic.state === 'load'

        // 데이터가 로드중일 경우 알림창을 띄운다.
        if (isLoad) {
          const message = ['전력계통정보를 요청중입니다.', '요청이 끝난 후 다시 시도해주세요.']
          vm.showNotifyModal(message)
        } else {
          vm.setRequestState('electronic', 'load')
          // 전력계통정보 API 요청
          api.getElectronicInfo(address, response => {
            if (response.error) {
              // API 요청 실패 시
              vm.setRequestState('electronic', 'error')
              console.log('get ElectronicInfo fail!', response)
            } else {
              const code = response.code

              // API 호출 성공 시, 현재 지번과 계통정보를 담는다.
              if (code === 'SC') {
                const electronic = response.result[0]
                vm.data.extend_buji_result['selectJibun'] = electronic[0].jibun
                vm.data.extend_buji_result['electronic'] = electronic
              }

              // 데이터 상태 초기화
              vm.setRequestState('electronic', vm.checkResponseCode(code))
            }
          })
        }
      },
      getJibunList () {
        const vm = this
        const address = vm.data.address[0]
        const isLoad = vm.requestState.electronic.state === 'load'

        // 데이터가 로드중일 경우 알림창을 띄운다.
        if (isLoad) {
          const message = ['전력계통정보를 요청중입니다.', '요청이 끝난 후 다시 시도해주세요.']
          vm.showNotifyModal(message)
        } else {
          // 전력계통정보
          const electronicInfo = new Promise((resolve, reject) => {
            api.getElectronicInfo(address, response => {
              // error 발생 시
              if (response.error) {
                reject(Error(response))
              } else {
                resolve(response)
              }
            })
          })
          // 인접지번정보
          const jibunInfo = new Promise((resolve, reject) => {
            api.getJibunList(address, response => {
              // error 발생 시
              if (response.error) {
                reject(Error(response))
              } else {
                resolve(response)
              }
            })
          })

          vm.setRequestState('electronic', 'load')
          // 전력계통정보와 인접지번정보를 모두 불러왔을 경우, 지번목록을 만들어준다.
          Promise.all([electronicInfo, jibunInfo]).then((response) => {
            // 전력계통정보 요청 상태코드
            const electronicCode = response[0].code

            if (electronicCode === 'SC') {
              const electronicData = response[0].result[0]
              const jibunData = response[1].result
              const jibunCode = response[1].code
              let jibun = ''
              let jibunList = []

              // 전력계통정보와 지번목록이 있는 경우에만 실행.
              if (jibunCode === 'SC') {
                jibun = electronicData[0].jibun
                jibunList.push(jibun)
                jibunList = jibunList.concat(jibunData['jibunList'])
              }

              // 계통정보, 계통정보의 지번, 인접지번 정보를 담는다.
              vm.data.extend_buji_result['electronic'] = electronicData
              vm.data.extend_buji_result['jibun'] = jibunData
              vm.data.extend_buji_result['jibunList'] = jibunList
              vm.data.extend_buji_result['selectJibun'] = jibun
            }

            // 데이터 상태 초기화
            vm.setRequestState('electronic', vm.checkResponseCode(electronicCode))
          }).catch(error => {
            vm.setRequestState('electronic', 'error')
            console.log('get JibunList error!', error)
          })
        }
      },
      getPhoneInfo () {
        const vm = this
        const address = vm.data['address']
        const isLoad = vm.requestState.phone.state === 'load'

        // 데이터가 로드중일 경우 알림창을 띄운다.
        if (isLoad) {
          const message = ['관련부서정보를 요청중입니다.', '요청이 끝난 후 다시 시도해주세요.']
          vm.showNotifyModal(message)
        } else {
          vm.setRequestState('phone', 'load')
          // 관련 부서 전화번호 API 요청
          api.getPhoneInfo(address, response => {
            if (response.error) {
              // API 요청 실패 시
              vm.setRequestState('phone', 'error')
              console.log('get phoneInfo!', response)
            } else {
              const code = response.code

              // API 요청 성공 시, 전화번호 정보를 담는다.
              if (code === 'SC') {
                const phone = response.result
                vm.data.extend_buji_result['electronic_phones'] = phone['electronic_phones']
                vm.data.extend_buji_result['examine_phones'] = phone['examine_phones']
              }

              // 데이터 상태 초기화
              vm.setRequestState('phone', vm.checkResponseCode(code))
            }
          })
        }
      },
      getAnalysisInfo () {
        const vm = this

        // 유료 회원이 아닐 경우, 알림창을 띄운다.
        if (!vm.isPaidMember) {
          vm.showChargeModal()
          return false
        }

        // 데이터가 로드중일 경우 알림창을 띄운다.
        const isLoad = vm.requestState.analysis.state === 'load'
        if (isLoad) {
          const message = ['발전분석을 요청중입니다.', '요청이 끝난 후 다시 시도해주세요.']
          vm.showNotifyModal(message)
        } else {
          // 설치조건
          const condition = vm.data['extend_profit_condition']
          const option = {
            address: vm.data.address[0],
            aspect: parseFloat(condition.aspect),
            tilt_angle: parseFloat(condition.tilt_angle),
            shade_lose: parseFloat(condition.shade_lose),
            suspension_date_cnt: parseFloat(condition.suspension_date_cnt)
          }

          vm.setRequestState('analysis', 'load')

          // 발전시뮬레이션 API 요청
          api.getAnalysisInfo(option, response => {
            if (response.error) {
              // API 요청 실패 시
              vm.setRequestState('analysis', 'error')
              console.log('get AnalysisInfo error!', response)
            } else {
              // API 요청 성공 시
              const analysis = response
              const isAlgorithm = condition['is_hz_algorithm']
              const average = parseFloat(analysis['simulate']['mu'])

              // 해줌 알고리즘을 사용 할 경우, 시뮬레이션 한 평균발전시간을 넣어준다.
              if (isAlgorithm) {
                vm.data.extend_profit_condition['average_generate_time'] = average
              }

              // 보고서의 발전시뮬레이션 값을 초기화 해준다.
              vm.data.extend_profit_result['analysis'] = analysis

              // 데이터 상태 초기화
              vm.setRequestState('analysis', 'success')
            }
          })
        }
      },
      checkProfitCondition (condition) {
        // 수익성 계산 시 입력 조건에 대한 유효성 검증
        if (condition) {
          const loanRate = condition.loan_rate
          const loanRate2 = condition.loan_rate2
          const redemptionPeriod = condition.redemption_period
          const loanPeriod = condition.loan_period

          // businessPeriod는 SMP 기간과 같다.
          const businessPeriod = condition.business_period
          const recPeriod = condition.rec_period

          // REC 기간이 SMP 기간보다 길 경우 알림창을 띄운다.
          if (businessPeriod < recPeriod) {
            const message = ['REC 기간은 SMP 기간보다 길 수 없습니다.']
            this.showNotifyModal(message)
            return false
          }

          // 대출1, 대출2가 있을경우, 상환기간이 입력 안되었으면 입력알림창을 띄운다.
          if ((loanRate > 0 || loanRate2 > 0) && redemptionPeriod === 0) {
            const message = ['상환기간을 입력하세요.']
            this.showNotifyModal(message)
            return false
          }

          // 대출이 있을경우, 상환기간이 거치기간의 합보다 길 경우 알림창을 띄운다.
          if (redemptionPeriod + loanPeriod > businessPeriod) {
            const message = ['상환기간과 거치기간의 합이 SMP기간보다 길 수 없습니다.']
            this.showNotifyModal(message)
            return false
          }

          return true
        }
      },
      getProfitInfo () {
        const vm = this
        const isLoad = vm.requestState.profit.state === 'load'

        // 데이터가 로드중일 경우 알림창을 띄운다.
        if (isLoad) {
          const message = ['수익분석을 요청중입니다.', '요청이 끝난 후 다시 시도해주세요.']
          vm.showNotifyModal(message)
          return false
        }

        // 수익 계산 시 유효한 수익 조건이 입력되었을 경우에만 API 실행
        let condition = vm.data.extend_profit_condition
        const isValidCondition = vm.checkProfitCondition(condition)

        if (isValidCondition) {
          // REC 계약기간이 문자열로 넘어가는것을 방지.
          condition.rec_period = parseInt(condition.rec_period)
          condition.business_period = parseInt(condition.business_period)

          // 데이터 요청 상태로 변경
          vm.setRequestState('profit', 'load')
          // 수익분석 API 요청
          api.getProfitInfo('E', condition, response => {
            if (response.error) {
              // API 요청 실패 시
              vm.setRequestState('profit', 'error')
              console.log('get ProfitInfo error!', response)
            } else {
              // API 요청 성공 시, 수익분석 결과와 조건을 초기화한다.
              vm.data.extend_profit_result.profit = response.profit
              vm.data.extend_profit_condition = response.condition

              // 데이터 상태 초기화
              vm.setRequestState('profit', 'success')
            }
          })
        }
      },
      getRecWeight: _.debounce(function () {
        const vm = this
        const data = {
          plant_type: vm.data.extend_profit_condition['plant_type'],
          expect_capacity: vm.data.extend_profit_condition['expect_capacity']
        }

        // REC 가중치 API 요청
        api.getRecWeight(data, response => {
          if (response.error) {
            // API 호출 실패 시
            console.log('get RecWeight error!', response)
          } else {
            // REC 가중치를 넣어준다.
            vm.data.extend_profit_condition['rec_weight'] = parseFloat(response.result.toFixed(3))
          }
        })
      }, 500),
      reLoadData (id) {
        const vm = this
        const Func = function () {
          this.map = function () { vm.getMapInfo() }
          this.land = function () { vm.getLandInfo() }
          this.restrict = function () { vm.getRestrictInfo() }
          this.arch = function () { vm.getArchInfo() }
          this.examine = function () { vm.getExamineInfo() }
          this.electronic = function () { vm.getJibunList() }
          this.phone = function () { vm.getPhoneInfo() }
          this.analysis = function () { vm.getAnalysisInfo() }
          this.profit = function () { vm.getProfitInfo() }
        }
        const reloadFunc = new Func()

        // 데이터 재요청 함수 실행
        reloadFunc[id]()
      },
      updateLandInfo () {
        const vm = this
        const isLoad = _.findKey(vm.requestState, (o) => { return o.state === 'load' })

        // 부지정보에 모든 데이터를 다 불러왔을 경우에만 업데이트 실행
        if (isLoad) {
          const message = ['사업지 분석중입니다.', '사업지분석이 끝난 후 다시 시도해주세요.']
          vm.showNotifyModal(message)
        } else {
          // 지도, 토지, 개발행위제한, 건물정보, 조례, 전력계통, 관련부서 정보 업데이트
          vm.getMapInfo()
          vm.getLandInfo()
          vm.getArchInfo()
          vm.getRestrictInfo()
          vm.getExamineInfo()
          vm.getJibunList()
          vm.getPhoneInfo()
        }
      },
      setModuleList (val, data) {
        // 넘어온 값이 없을 경우 리턴
        if (typeof data === 'undefined') return

        const vm = this
        const module = { module: data['id'], module__name: data['name'] }
        const len = vm.data['master_module'].length
        // 현재 선택된 모듈이 목록에 있는지 확인
        const isSelect = _.find(vm.data['master_module'], ['module', data['id']])

        // 이미 목록안에 선택된 모듈이 존재할 경우
        if (typeof isSelect !== 'undefined') {
          alert('이미 선택된 모듈입니다.')
        } else {
          // 모듈에 최대 선택 갯수는 3개이다.
          if (len >= 3) {
            alert('최대 3개까지 선택 가능합니다.')
          } else {
            this.data['master_module'].push(module)
          }
        }

        // 드롭다운 리스트에 선택항목 초기화
        vm.selectModule = ''
        vm.$refs.selectModule.initSelect('')
      },
      removeModule (id) {
        const vm = this

        // 선택된 ID값을 비교하여 항목에서 제거
        const list = _.remove(vm.data.master_module, (obj) => {
          return obj.module !== id
        })

        // 값이 제거된 리스트로 초기화
        vm.data.master_module = list
      },
      setInverterList (val, data) {
        // 넘어온 값이 없을 경우 리턴
        if (typeof data === 'undefined') return

        const vm = this
        const inverter = { inverter: data['id'], inverter__name: data['name'] }
        const len = vm.data['master_inverter'].length
        // 현재 선택된 인버터가 목록에 있는지 확인
        const isSelect = _.find(vm.data['master_inverter'], ['inverter', data['id']])

        // 이미 목록안에 선택된 인버터가 존재할 경우
        if (typeof isSelect !== 'undefined') {
          alert('이미 선택된 인버터입니다.')
        } else {
          // 모듈에 최대 선택 갯수는 3개이다.
          if (len >= 3) {
            alert('최대 3개까지 선택 가능합니다.')
          } else {
            this.data['master_inverter'].push(inverter)
          }
        }

        // 드롭다운 리스트에 선택항목 초기화
        vm.selectInverter = ''
        vm.$refs.selectInverter.initSelect('')
      },
      removeInverter (id) {
        const vm = this

        // 선택된 ID값을 비교하여 항목에서 제거
        const list = _.remove(vm.data.master_inverter, (obj) => {
          return obj.inverter !== id
        })

        // 값이 제거된 리스트로 초기화
        vm.data.master_inverter = list
      },
      showModal (id) {
        // 모달창 활성화
        $('#' + id).modal('show')
      },
      openConnectFeeCalculator () {
        // 표준시설부담금 계산기
        // 한전 사이버지점(cyber.kepco.co.kr)이 한전ON 으로 통합되면서 기존 주소는
        // 한전ON 메인으로 리다이렉트된다. 계산기 페이지로 직접 연결한다. (2026-09-03)
        const url = 'https://online.kepco.co.kr/PRM076D00'
        const left = (screen.width / 2) - (1280 / 2)
        const top = (screen.height / 2) - (720 / 2)

        window.open(url, 'preview', `menubar=0, resizable=0, width=1280, height=720, top=${top}, left=${left} + left`)
      },
      showChargeModal () {
        // Main.vue로 이벤트 전달
        eventHub.$emit('showChargeModal')
      },
      showSaveModal (type) {
        /**
         * 보고서 저장, 복사 시 알림창으로 사용자에게 컨펌받을 내용을 정의하는 함수입니다.
         * 보고서 저장 모달을 출력하기 전 유료 회원 여부와 데이터 요청 상태를 체크합니다.
         * 다른 사람이 생성 한 보고서 일 경우 저장을 하지않고 미리보기 창을 띄웁니다.
         * 본인이 생성 한 보고서 일 경우 기존 저장, 복사 알림창을 띄웁니다.
         */

        const vm = this

        // 유료 회원이 아닐 경우, 알림창을 띄운다.
        const isPaidMember = vm.isPaidMember
        if (!isPaidMember) {
          vm.showChargeModal()
          return false
        }

        // 데이터 요청중인 상태가 있을 경우, 알림창을 띄운다.
        const isLoad = _.findKey(vm.requestState, (o) => { return o.state === 'load' })
        if (isLoad) {
          const message = ['해당 부지에 대한 분석중입니다.', '분석이 끝난 후 다시 시도해주세요']
          vm.showNotifyModal(message)
          return false
        }

        // 이미 저장된 보고서에 로그인한 유저가 작성자가 아닐 경우, 저장 버튼 클릭 시 미리보기 창을 띄운다.
        const data = vm.data
        const isNewReport = typeof data.reg_by === 'undefined'
        const isCreator = data.reg_by === vm.user.id
        const isSave = type === 'save'

        if (!isNewReport && !isCreator && isSave) {
          vm.openPreview()
          return false
        }

        // 알림창에 출력할 내용을 설정한다
        if (type === 'copy') {
          vm.saveModal['param'] = 'copy'
          vm.saveModal['fields'] = [
            {
              id: 'project_name',
              name: '프로젝트명',
              type: 'text',
              class: 'margin-0',
              helpText: '새로운 프로젝트명을 입력하세요.'
            }
          ]
        } else {
          vm.saveModal['param'] = 'save'
          vm.saveModal['fields'] = [
            {
              type: 'message',
              message: ['보고서를 저장하시겠습니까?'],
              class: 'text-center'
            }
          ]
        }

        // 알림창 활성화
        vm.$refs.saveModal.show()
      },
      showNotifyModal (message = []) {
        // 전달받은 알림 메세지를 설정 후 모달창 활성화
        this.notifyModal.fields[0].message = message
        this.$refs.notifyModal.show()
      },
      openSite (url, target = 'preview', setAttributes = true) {
        let attributes = ''

        if (setAttributes) {
          const left = (screen.width / 2) - (1280 / 2)
          const top = (screen.height / 2) - (720 / 2)

          attributes = `menubar=0, resizable=0, width=1280, height=720, top=${top}, left=${left}`
        }

        window.open(url, target, attributes)
      },
      changeGrade (state) {
        const vm = this
        const grade = vm.data['extend_grade']

        // 현재 선택된 추진가능성으로 업데이트
        if (grade === state) {
          vm.data['extend_grade'] = '미정'
        } else {
          vm.data['extend_grade'] = state
        }
      },
      checkReference (state, i) {
        const vm = this
        const originName = vm.data.reference_file[i].origin_name

        // 현재 선택된 레퍼런스 저장. 중복으로 선택 가능.
        if (originName === state) {
          // 이미 선택되어 있으면 해제처리
          vm.data['reference_file'][i].origin_name = ''
          vm.data['reference_file'][i].datafile = ''
        } else {
          // 새로 선택한 거라면 선택처리
          vm.data['reference_file'][i].origin_name = state
          vm.data['reference_file'][i].datafile = '2_install_ref_' + i + '_m.png'
        }
      },
      openPreview () {
        const vm = this
        const reportId = vm.data.id
        const isSave = vm.data.extend_status

        // 다른 사람이 작성한 보고서 내용이며 생성되지 않은 보고서 일 경우 알림을 띄운다.
        if (isSave !== 'U') {
          return alert('본인이 작성한 보고서가 아닙니다.')
        }

        if (reportId) {
          // const preview = '/extendpreview/' + reportId + '/'
          const preview = '/preview/' + reportId + '/?type=extend'
          const left = (screen.width / 2) - (1280 / 2)
          const top = (screen.height / 2) - (720 / 2)
          const open = window.open(preview, 'preview', 'menubar=0, resizable=0, width=1280, height=720, top=' + top + ', left=' + left)

          // 팝업이 차단되어 있을 경우, 알림창을 띄운다.
          if (open === null || typeof open === 'undefined' || open.screenLeft === 0) {
            // alert('팝업 차단이 설정되어 있습니다. ' +
            //   '\n차단기능을 해제(팝업허용)해주세요. ' +
            //   '\n팝업 차단이 되있을 경우 일부기능이 정상적으로 동작하지 않습니다.')
          }
        }
      },
      addEventListenerPriceInput () {
        // SMP 가격 필드 focus, blur 이벤트 등록
        const smpPrice = document.querySelector('#smpPrice')
        smpPrice.addEventListener('focus', () => {
          this.isFocusSmpPrice = true
        })
        smpPrice.addEventListener('blur', () => {
          setTimeout(() => {
            this.isFocusSmpPrice = false
            this.isEditingSmpPrice = false
          }, 150)
        })

        // REC 가격 필드 focus, blur 이벤트 등록
        const recPrice = document.querySelector('#recPrice')
        recPrice.addEventListener('focus', () => {
          this.isFocusRecPrice = true
        })
        recPrice.addEventListener('blur', () => {
          setTimeout(() => {
            this.isFocusRecPrice = false
            this.isEditingRecPrice = false
          }, 150)
        })
      },
      selectPriceItem (type = '', price = 0) {
        this.data.extend_profit_condition[`${type}_price`] = parseFloat(price)
      },
      toFixed: _.debounce(function (id) {
        /**
         * input type = number인 필드에 값이 입력 될 때 호출되는 함수입니다.
         * 최종 이벤트 발생 후 1초뒤에 실행합니다.
         * 입력이 공백 일 경우 0을 자동으로 반환합니다.
         * 입력 된 수에 소수점 자릿수를 잘라 반환합니다.
         */

        const vm = this
        const data = $.extend(true, {}, vm.data.extend_profit_condition)
        const value = data[id]
        const number = isNaN(parseFloat(value)) ? 0.000 : parseFloat(parseFloat(value).toFixed(3))

        // 해당 필드에 데이터 Set
        vm.$set(vm.data.extend_profit_condition, id, number)
      }, 300),
      calcInstallFee: _.debounce(function () {
        const vm = this
        const data = vm.data['extend_profit_condition']
        const capcity = parseFloat(data['expect_capacity'])
        const price = parseFloat(data['unit_price'])
        const install = parseFloat(((capcity * price) * 0.01).toFixed(3))

        // 용량 * kW당 공사비를 총공사비 항목에 넣어준다.
        vm.data.extend_profit_condition['install_fee'] = install
      }, 300),
      calcOmFee: _.debounce(function () {
        // 100kW당 2.5 백만원/년을 연간 유지비 데이터에 넣어준다.
        const capcity = parseFloat(this.data.extend_profit_condition.expect_capacity)
        const omFee = parseFloat(((capcity / 100) * 2.5).toFixed(3))

        this.data.extend_profit_condition.om_fee = omFee
      }, 300),
      calcTotalCost: _.debounce(function () {
        const vm = this
        const data = vm.data['extend_profit_condition']

        // 총 공사비, 계통연계비, 착수금, 토지비, 대출수수료, 기타사업비
        const install = parseFloat(data['install_fee'])
        const connect = parseFloat(data['connect_fee'])
        const retaining = parseFloat(data['retaining_fee'])
        const land = parseFloat(data['land_fee'])
        const loan = parseFloat(data['loan_commission_fee'])
        const etc = parseFloat(data['business_etc_fee'])

        // 총 사업비 = 총 공사비 + 게통연계비 + 착수금 + 토지비 + 대출수수료 + 기타사업비
        const total = parseFloat((install + etc + connect + land + retaining + loan).toFixed(3))

        // 총 사업비를 넣어준다.
        vm.data.extend_profit_condition['business_total_cost'] = total
      }, 300),
      calcLoan: _.debounce(function () {
        const vm = this
        const data = vm.data['extend_profit_condition']
        const total = parseFloat(data['business_total_cost'])
        const rate = parseFloat(data['loan_rate'])
        const rate2 = parseFloat(data['loan_rate2'])

        // 대출금액 = 총 사업비 / 대출비율
        const loan = parseFloat((total * (rate * 0.01)).toFixed(3))
        const loan2 = parseFloat((total * (rate2 * 0.01)).toFixed(3))

        // 대출금액을 넣어준다
        vm.data.extend_profit_condition['loan'] = loan
        vm.data.extend_profit_condition['loan2'] = loan2
      }, 300)
    },
    created () {
      /**
       * Vue 인스턴스 생성 시 처음 실행되는 단계입니다.
       * 원클릭 사업검토페이지 진입 시 localStorage에 jwt token 여부를 확인합니다.
       * 없을 경우 로그인 화면으로 이동, 있을 경우, Token validation 합니다.
       * validation 실패 할 경우 로그인화면으로 이동, 성공 할 경우 페이지를 초기화 합니다.
       */

      const token = localStorage.getItem('_t')
      if (!token) {
        this.$router.push({name: 'login'})
        return false
      }

      this.$store.dispatch('inspectToken', token).then(() => {
        if (typeof this.user.id !== 'undefined') {
          this.$store.dispatch('checkAccessMenu').then(() => {
            this.init()
          })
        }
      })
    },
    beforeDestroy () {
      // 켄도 라이브러리에 의해 생성된 엘리먼트 제거
      kendo.destroy(document.body)

      // store에 원클릭 사업검토 관련 데이터를 초기화한다.
      this.setReportData({})
    }
  }
</script>

<style lang="scss" scoped>
  @import '~@/assets/css/components/modal';

  #extend-report {
    &.index-active {
      // 스크린사이즈가 2065px 이상 일 경우, 별도에 레이이아웃 조정이 필요없다.
      @media (min-width: 1200px) and (max-width: 2065px) {
        .index-wrap {
          width: 220px;
          height: 1px;
          float: left;
        }

        .extend-container {
          width: calc(100% - 220px);
          height: 100%;
          float: left;
        }

        .extend-header {
          width: calc(100% - 220px);
        }
      }

      @media (min-width: 1200px) and (max-width: 1665px) {
        .extend-container {
          .container {
            width: calc(100% - 96px);
          }
        }
      }
    }

    // Header
    .extend-header {
      position: fixed;
      width: 100%;
      padding: 24px 0;
      border-bottom: 1px solid $border-color;
      background-color: $hzc-white;
      z-index: 5;

      .title-box {
        width: 50%;
        max-width: calc(100% - 350px);
        float: left;
      }

      .title-edit-box {
        width: calc(100% - 32px);
        height: 32px;
        float: left;
      }

      .btn-box {
        width: 50%;
        min-width: 350px;
        margin-top: 8px;
        float: left;
      }

      .title-box, .btn-box {
        .date-tag {
          color: $hzc-gray-05;
        }

        .address-tag {
          color: $hzc-gray-06;
        }

        .state-tag {
          display: inline-block;
          float: left;
        }

        .project-title {
          display: inline-block;
          font-size: 24px;
          font-weight: bold;
          font-style: normal;
          font-stretch: normal;
          letter-spacing: -1px;
          color: $font-color;
          line-height: 32px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          float: left;
        }

        .hz-input-default {
          border: 1px solid $hzc-gray-04;
        }

        .glyphicon-pencil {
          top: 11px;
          color: #7a98b6;
          font-size: 12px;
          cursor: pointer;
          float: left;
        }
      }

      @media (max-width: 767px) {
        padding: 16px;

        .title-box {
          max-width: initial;
          width: 100%;
        }
        .btn-box {
          display: none;
        }
      }

    }

    // Content
    .extend-content {
      padding-top: 132px;

      .card {

        .collapse {
          overflow: hidden;
        }

        .card-header {
          a {
            display: block;
            width: 100%;
            padding: 16px 0;
            margin: 0;
            background-color: $hzc-white;
            border-bottom: 1px solid $border-color;
            font-size: 22px;
            font-weight: bold;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.18;
            letter-spacing: -1.1px;
            color: $font-color;
            text-decoration: none;
          }

          .glyphicon-triangle-bottom {
            margin-top: 5px;
            font-size: 14px;
          }
        }

        .card-body {
          padding: 16px 0;

          label {
            position: initial;
            margin: 0;
            line-height: 32px;
          }

          input {
            width: 100%;
          }

          .col-md-6, .col-xs-12 {
            position: initial;
            padding: 0;
          }

          .card-category {
            margin: 0 0 16px 0;
            font-size: 16px;
            font-weight: bold;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.5;
            letter-spacing: -1.3px;
            color: $font-color;
          }

          .form-group {
            padding: 0 16px;
            margin-bottom: 8px;

            input, .hz-btn-default {
              width: 100%;
            }

            .col-md-8 {
              position: relative;
            }

            .col-xs-6 {
              padding: 0;
            }
          }

          .related-field {
            label {
              color: $hzc-gray-06;
            }
          }

          .introduction-field {
            cursor: pointer;
            &:hover {
              text-decoration: underline;
            }
          }

          .review-state-box {
            height: 40px;
            line-height: 40px;
            border: 1px solid #e1e6f3;
            color: $primary-color-v2;
            font-weight: bold;
            font-size: 14px;
            text-align: center;
            cursor: pointer;
            background-color: #f7f8fc;
            box-shadow: 0 1px 1px 0 rgba(102, 105, 109, 0.32);

            &:hover {
              background-color: $primary-color-v2;
              color: $hzc-white;
            }
            &:active {
              background-color: darken($primary-color-v2, 10%);
              color: $hzc-white;
            }
          }

          .review-active {
            background-color: $primary-color-v2;
            color: $hzc-white;
          }

          .select-product-list {
            min-height: 32px;
            max-height: 148px;
            overflow-y: auto;
            padding: 0 8px;
            background-color: $hzc-white;
            border: 1px solid $hzc-gray-04;
            > li {
              line-height: 32px;
              color: $header-color;
              span {
                float: right;
                font-size: 14px;
                cursor: pointer;
                &:hover {
                  font-weight: bold;
                }
              }
            }
          }

          .hz-default-tooltip {
            float: right;
            margin-right: 24px;

            @media (max-width: 991px) {
              float: initial;
              margin-left: 16px;
            }
          }
        }
      }

      .hz-unit {
        position: absolute;
        top: 9px;
        right: 16px;
        color: #adb5bd;
        font-size: 12px;
        font-weight: bold;
      }
    }

    // Footer
    .extend-footer {
      padding: 80px 0;

      button {
        width: 168px;
        margin: 0 8px;

        @media (max-width: 767px) {
          width: 100%;
          margin: 0;

          &:first-child {
            margin-bottom: 8px;
          }
        }
      }
    }

    .recent-input-price {
      position: absolute;
      width: 100%;
      height: auto;
      max-height: 250px;
      overflow: auto;
      margin-top: 4px;
      border-radius: 4px;
      -webkit-box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.13);
      box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.13);
      background-color: $hzc-white;
      text-align: left;
      z-index: 7;

      ul {
        overflow: auto;
      }

      li {
        position: relative;
        padding: 4px 8px;
        font-size: 14px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.43;
        letter-spacing: -0.35px;
        color: $font-color;
      }

      li:first-child {
        padding-top: 8px;
      }

      li:last-child {
        padding-bottom: 8px;
      }

      li:hover {
        background-color: #f5f2fc;
        color: $purple;
      }
    }

    // Contact FAB
    .contact-fab {
      .fab {
        position: fixed;
        right: 32px;
        bottom: 32px;
        width: 56px;
        height: 32px;
        border: none;
        border-radius: 4px;
        box-sizing: content-box;
        box-shadow: 0 6px 10px 0 rgba(0, 0, 0, 0.14),
        0 1px 18px 0 rgba(0, 0, 0, 0.12),
        0 3px 5px -1px rgba(0, 0, 0, 0.2);
        cursor: pointer;
        outline: none;
        overflow: hidden;
        text-align: center;
        background-color: $primary-color-v2;
        color: $hzc-white;
        font-size: 12px;
        z-index: 5;

        &:hover {
          background-color: darken($primary-color-v2, 10%);
          color: $hzc-white;
        }
      }
      .fab-text {
        padding: 12px 0;
        text-decoration: none;
        font-weight: bold;
      }
    }

    // API Request state Alert UI
    .alert-wrap {
      width: 320px;
      position: fixed;
      top: 184px;
      right: 32px;
      z-index: 7;

      @media (max-width: 767px) {
        width: calc(100% - 16px);
        top: 72px;
        right: 8px;
      }
    }

    @media (max-width: 991px) {
      .extend-header {
        padding: 16px;
      }

      .extend-content {
        padding: 124px 16px 0 16px;

        .card .card-body .form-group {
          padding: 0;
        }

        .card-category {
          margin-top: 24px;
        }
      }

      .extend-footer {
        padding: 48px 16px;
      }

      .col-xs-12 {
        padding: 0;
      }
    }

    ul, li {
      list-style: none;
      margin: 0;
      padding: 0;
    }

    input[type='number'] {
      -moz-appearance: textfield;
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
    }

    input:-moz-read-only { /* For Firefox */
      background-color: $box-bgcolor;
    }

    input:read-only {
      background-color: $box-bgcolor;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/extend/ExtendReport.vue